import React from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { Button } from './button';
import { Facebook, Twitter, Linkedin, Link2, Share2 } from 'lucide-react';
import { Instagram } from 'lucide-react';


const ShareDialog = ({ selectedEmotion = 'an emotion', cardUrl = 'https://express.arake.app/wall' }) => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const shareText = `I just expressed ${selectedEmotion} with #Express 💌`;
    const fullShareText = `${shareText}\nExplore the Wall ➜ ${cardUrl}\nThen click Express to create yours 💌`;


    return (

        <Dialog>
            <div onClick={(e) => e.stopPropagation()}></div>
            <DialogTrigger asChild>
                <Button variant="outline" size="icon">
                    <Share2 className="h-4 w-4" />
                </Button>
            </DialogTrigger>


            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Share your message</DialogTitle>
                </DialogHeader>

                <div className="grid grid-cols-2 gap-4 pt-4">
                    {/* Instagram */}
                    <Button
                        variant="outline"
                        onClick={() => {
                            navigator.clipboard.writeText(cardUrl);
                            alert('Copied link! You can paste it in your Instagram story or bio.');
                        }}
                    >
                        <Instagram className="mr-2 h-4 w-4" /> Instagram
                    </Button>

                    {/* Facebook */}
                    <Button
                        variant="outline"
                        onClick={() =>
                            window.open(
                                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(cardUrl)}`,
                                '_blank'
                            )
                        }
                    >
                        <Facebook className="mr-2 h-4 w-4" /> Facebook
                    </Button>

                    {/* Twitter */}
                    <Button
                        variant="outline"
                        onClick={() =>
                            window.open(
                                `https://twitter.com/intent/tweet?text=${encodeURIComponent(fullShareText)}`,
                                '_blank'
                            )
                        }
                    >
                        <Twitter className="mr-2 h-4 w-4" /> X
                    </Button>

                    {/* LinkedIn */}
                    <Button
                        variant="outline"
                        onClick={() => {
                            navigator.clipboard.writeText(fullShareText);
                            window.open(
                                `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(cardUrl)}`,
                                '_blank'
                            );
                        }}
                    >
                        <Linkedin className="mr-2 h-4 w-4" /> LinkedIn
                    </Button>

                    {/* Copy Link */}
                    <Button
                        variant="outline"
                        onClick={() => {
                            navigator.clipboard.writeText(cardUrl);
                            alert('Card link copied to clipboard!');
                        }}
                    >
                        <Link2 className="mr-2 h-4 w-4" /> Copy Link
                    </Button>


                    {/* WhatsApp (Mobile only) */}
                    {isMobile && (
                        <Button
                            variant="outline"
                            onClick={() =>
                                window.open(
                                    `https://wa.me/?text=${encodeURIComponent(fullShareText)}`,
                                    '_blank'
                                )
                            }
                        >
                            <img
                                src="https://img.icons8.com/ios-filled/20/000000/whatsapp.png"
                                alt="WhatsApp"
                                className="mr-2"
                            />
                            WhatsApp
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ShareDialog;
